import { RegisterOptions } from 'react-hook-form';
import { ActivateRangeErrorCodes } from '../../api/manufactured_chips';

export type RowProps = {
  addBottomMargin?: boolean;
};

export type HalfScreenProps = {
  isLeftHalf?: boolean;
};

export enum BatchEntryStep {
  DataEntry = 0,
  Summary = 1,
}

export type ManufacturingPageFormFields = {
  lotNumber: string;
  product?: string;
  firstLabel: string;
  secondLabel: string;
  secondLastLabel: string;
  lastLabel: string;
  expiryDate?: string;
  predictionModel?: string;
};

export const defaultFieldValues: ManufacturingPageFormFields = {
  lotNumber: '',
  product: undefined,
  firstLabel: '',
  secondLabel: '',
  secondLastLabel: '',
  lastLabel: '',
  expiryDate: undefined,
  predictionModel: undefined,
};

export type AddNewBatchModalRules = {
  lotNumber: RegisterOptions;
  product: RegisterOptions;
  firstLabel: RegisterOptions;
  secondLabel: RegisterOptions;
  secondLastLabel: RegisterOptions;
  lastLabel: RegisterOptions;
  expiryDate: RegisterOptions;
  predictionModel: RegisterOptions;
};

export const addNewBatchModalRules: AddNewBatchModalRules = {
  lotNumber: {
    required: 'Required field',
  },
  product: {
    required: 'Required field',
  },
  firstLabel: {
    required: 'Required field',
  },
  secondLabel: {
    required: 'Required field',
  },
  secondLastLabel: {
    required: 'Required field',
  },
  lastLabel: {
    required: 'Required field',
  },
  expiryDate: {
    required: 'Required field',
  },
  predictionModel: {
    required: 'Required field',
  },
};

export const ManufacturingErrorContent = new Map<
  ActivateRangeErrorCodes,
  { title: string; description: string }
>([
  [
    ActivateRangeErrorCodes.ID_NOT_FOUND,
    {
      title: 'Batch ID Not Found',
      description: 'We could not locate the batch ID. Please review your entries and try again.',
    },
  ],
  [
    ActivateRangeErrorCodes.INVALID_ORDER,
    {
      title: 'Invalid Order Details',
      description:
        'Some of the order details are incorrect or incomplete. Please review your entries and try again.',
    },
  ],
  [
    ActivateRangeErrorCodes.RANGE_TOO_LARGE,
    {
      title: 'Range Too Large',
      description:
        'The range you’ve entered covers too many IDs. Please reduce the range and try again.',
    },
  ],
  [
    ActivateRangeErrorCodes.RANGE_OVERLAPS_ACTIVATED,
    {
      title: 'Range Overlaps with Activated IDs',
      description:
        'Some IDs in this range have already been activated. Please adjust the range to exclude active IDs before continuing.',
    },
  ],
]);
